/**
 * Created by lu on 2018/5/4.
 */
var nb = require('../../../nb');
// var util = require('../../../util');
var productListLength, key;
module.exports = nb.define({
    parent: nb.Model,
    mapping: {
        productList: function (inList) {    //处理接口字段与model字段一致
            productListLength = inList.length;
            var Model = require('./ProductList');
            var model = new Model;
            model.set('items', inList.slice(0, 4) || []); //最多截取4个
            if (productListLength > 4) {
                this.set('lengthState', 'has')
            }
            return model;
        }
    },
    method: {
        init: function () {

            this.onChange('createTime', function (inEvent, inTime) {
                return inTime;   //util.timeFormat(inTime, '-', true);
            }, this, {before: true});
            this.onChange('amount', function (inEvent, inAmount) {
                return '￥' + inAmount.toFixed(2); //util.numberFormat(inAmount / 100, 2)
            }, this, {before: true});

            this.onChange('status', function (inEvent, inStatus) {
                var statusMap = nb.model.get('statusMap');
                this.set('statusText', statusMap[inStatus].statusText);

                //锁定模块
                if (inStatus == 19) {
                    this.set('lockClass', 'lock-state-box');
                } else {
                    this.set('lockClass', 'normal-state-box');
                }
            }, this);

            this.onChange('id', function (inEvent, inId) {
                // this.set('goPayHref','createOrder.html?id='+inId);//订单ID
                this.set('orderDetailHref', 'orderDetail.html?id=' + inId);//订单详情
            }, this);


            this.onChange('dataReady', function (inEvent) {
                key = nb.model.get('changeLanguageReady');

                var salesName = this.get('salesName');
                this.set('sales-state', salesName ? 'inline-block' : 'none');

                var payType = this.get('payType');
                var status = this.get('status');

                if (this.get('payType') == '线下支付') {
                    if (key = 'cn')
                        this.set('goPayText', '上传凭证');
                    else
                        this.set('goPayText', 'Voucher');
                }

                //已锁定
                if (this.get('status') == 19) {
                    if (key = 'cn')
                        this.set('lockTips', '您的订单被锁定，请联系销售客服解决！');
                    else
                        this.set('lockTips', 'Your order is locked, please contact sales customer service solution！');
                }

                //线下支付，在'待发货'情况下，隐藏取消按钮
                if (payType == '线下支付' && status.toString() == '3')
                    this.set('cancelState', 'hide');

                //货到付款
                if (payType == '货到付款') {

                    //在'待收货'，隐藏'确认收货','退货退款'
                    if (status.toString() == '6') {
                        this.set('confirmState', 'hide');
                        this.set('afterSaleState', 'hide');
                    }

                }


                if (key == 'en') {
                    var payTypeEn = '';

                    // 微信 支付宝 线上支付 账期支付 线下支付 组合支付 货到付款 未选择支付方式
                    if (payType == '微信')
                        payTypeEn = 'WeChat';
                    if (payType == '支付宝')
                        payTypeEn = 'Alipay';
                    if (payType == '线上支付')
                        payTypeEn = 'Online payment';
                    if (payType == '账期支付')
                        payTypeEn = 'Bill payments';
                    if (payType == '线下支付')
                        payTypeEn = 'Offline Payment';
                    if (payType == '组合支付')
                        payTypeEn = 'Combination of pay';
                    if (payType == '货到付款')
                        payTypeEn = 'Cash on Delivery';
                    if (payType == '未选择支付方式')
                        payTypeEn = 'None';

                    this.set('payType', payTypeEn);
                }


            }, this, {before: true});


            // this.onChange('dataReady', function (inEvent) {
            //
            //     var salesName = this.get('salesName');
            //     this.set('sales-state', salesName ? 'inline-block' : 'none');
            //
            //     var payType = this.get('payType');
            //     var status = this.get('status');
            //
            //
            //     //线下支付订单在'待发货'情况下，隐藏取消按钮
            //     if (payType == '线下支付' && status.toString() == '3')
            //         this.set('cancelState', 'hide');
            //
            // }, this, {before: true});


        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/order/model/OderListItem.js
// module id = 682
// module chunks = 3